module.exports = __webpack_public_path__ + "img/wing.c736222f.png";